import { selectMultipleChoiceExamStep } from '../../../store/exam/selectors';
import { selectProfileData } from '../../../store/workspace/selectors';
import { setMultipleChoiceExamStep } from '../../../store/exam/slice';
import { getProfileDataThunk } from '../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../store/store';
import { getUserInfoThunk } from '../../../store/auth/thunks';
import { selectUserId } from '../../../store/auth/selectors';
import { useLocation, useNavigate } from 'react-router-dom';
import ExamLayout from '../../../layouts/Exam';
import ExamEnd from './containers/ExamEnd';
import KYC from '../../../containers/KYC';
import Exam from './containers/Exam';
import { useEffect } from 'react';

function MultipleChoiceExam() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const profile = useSelector(selectProfileData);
    const step = useSelector(selectMultipleChoiceExamStep);

    useEffect(() => {
        !location?.state?.examId && navigate('/workspace');
        !userId && dispatch(getUserInfoThunk());
        !profile && dispatch(getProfileDataThunk());

        return () => {
            dispatch(setMultipleChoiceExamStep('KYC'));
        }
    }, []);

    return (
        <ExamLayout headerTitle='Multiple choice exam'>
            {step === 'KYC' && <KYC
                userId={userId}
                profile={profile}
                jobId={location?.state?.jobId}
                examId={location?.state?.examId}
                onSuccess={() => dispatch(setMultipleChoiceExamStep('Exam'))}
            />}

            {step === 'Exam' && <Exam />}
            {step === 'ExamEnd' && <ExamEnd />}
        </ExamLayout>
    )
};

export default MultipleChoiceExam;
